import type { UserPlan } from "@/lib/auth/plans";
import { PLAN_MAX_RANGE_SEC } from "@/lib/auth/planLimits";

export const DAY_IN_SECONDS = 24 * 60 * 60;

export type RangeOption = {
  label: string;
  key: string;
  seconds: number | null;
};

/** Check if a range option is locked for the given plan */
export function isRangeLocked(option: RangeOption, plan: UserPlan): boolean {
  if (plan === "pro" || plan === "studio") return false;
  const max = PLAN_MAX_RANGE_SEC[plan];
  return option.seconds !== null && option.seconds > max;
}

export const RANGE_OPTIONS: RangeOption[] = [
  { label: "48h", key: "48h", seconds: 48 * 60 * 60 },
  { label: "7 days", key: "7d", seconds: 7 * DAY_IN_SECONDS },
  { label: "30 days", key: "30d", seconds: 30 * DAY_IN_SECONDS },
  { label: "3 months", key: "3m", seconds: 90 * DAY_IN_SECONDS },
  { label: "1 year", key: "1y", seconds: 365 * DAY_IN_SECONDS },
  { label: "All time", key: "5y", seconds: 5 * 365 * DAY_IN_SECONDS },
];

// Range options for followers (without 48h, default is 7d)
export const FOLLOWERS_RANGE_OPTIONS: RangeOption[] = [
  { label: "7 days", key: "7d", seconds: 7 * DAY_IN_SECONDS },
  { label: "30 days", key: "30d", seconds: 30 * DAY_IN_SECONDS },
  { label: "3 months", key: "3m", seconds: 90 * DAY_IN_SECONDS },
  { label: "1 year", key: "1y", seconds: 365 * DAY_IN_SECONDS },
  { label: "All time", key: "5y", seconds: 5 * 365 * DAY_IN_SECONDS },
];

/**
 * Game-page followers chart. Signed-out visitors start on 7 days, all their
 * plan allows; signed-in visitors start on 30 days. The 1d/7d/30d change
 * tiles above the chart are computed from the loaded history, so the 30d tile
 * needs a range of at least 30 days.
 */
export const FOLLOWERS_RANGE_OPTIONS_GAME: RangeOption[] = [
  { label: "7 days", key: "7d", seconds: 7 * DAY_IN_SECONDS },
  { label: "30 days", key: "30d", seconds: 30 * DAY_IN_SECONDS },
  { label: "3 months", key: "3m", seconds: 90 * DAY_IN_SECONDS },
  { label: "1 year", key: "1y", seconds: 365 * DAY_IN_SECONDS },
  { label: "All time", key: "5y", seconds: 5 * 365 * DAY_IN_SECONDS },
];

export const CHART_HEIGHT_DESKTOP = 400;
export const CHART_HEIGHT_MOBILE = 280;
